var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.929,
    height: 53.433,
    viewBox: "0 0 56.929 53.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image-default-icon",
    d: "M46.528,50.661,41.939,49.4l-.01-12.694,4.39,1.235,6.329-23.626L20.587,5.726l-2.113,7.881H14.857L18.115,1.448l38.814,10.4-10.4,38.814Zm-6.235,4.22H0V14.7H40.294ZM36.8,18.19H3.494V42.649H36.8ZM13.727,35.631l3.993-6.457L21.713,33.2l5.49-8.267,5.742,14.226H7.487l3.244-6.489ZM11.34,28.8a2.62,2.62,0,1,1,2.62-2.62A2.62,2.62,0,0,1,11.34,28.8Z",
    transform: "translate(0 -1.448)",
    fill: "#a5adc6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultIcon);
export default __webpack_public_path__ + "static/media/image-default-icon.eef3cbb8878039730eaad72c3d2b6300.svg";
export { ForwardRef as ReactComponent };